module.exports = __webpack_public_path__ + "static/media/cq_montante b.29434b26.svg";